<template>
  <div class="match-page-footer">
    <div class="match-page-footer-pc">
      <DownloadGameFooter class="footer--match-theme" />
    </div>
    <div class="match-page-footer-mobile">
      <DownloadGameFooterMobile class="footer--match-theme" />
    </div>
  </div>
</template>

<script>
import DownloadGameFooter from '@/components/pc_components/DownloadGameFooter.vue'
import DownloadGameFooterMobile from '@/components/footer/DownloadGameFooterMobile.vue'

export default {
  name: 'MatchPageFooter',
  components: {
    DownloadGameFooter,
    DownloadGameFooterMobile,
  },
}
</script>

<style scoped lang="scss">
.match-page-footer-mobile {
  display: none;
}

@media (max-width: 750px) {
  .match-page-footer-pc {
    display: none;
  }

  .match-page-footer-mobile {
    display: block;
  }
}
</style>
